import { useCallback, useEffect, useRef, useState } from "react";

export const useKeyboardSequenceToggle = (sequence: string): boolean => {
  const inputRef = useRef("");
  const [isEnabled, setIsEnabled] = useState(false);

  const handleKeyPress = useCallback(
    (e: KeyboardEvent) => {
      // Ignore keypress events when user is typing in input fields, textareas, or contenteditable elements
      const target = e.target as HTMLElement;
      if (
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.contentEditable === "true" ||
        target.closest("[contenteditable]")
      ) {
        return;
      }

      // Only process single character keys (not special keys like Enter, Escape, etc.)
      if (e.key.length !== 1) {
        return;
      }

      inputRef.current = (inputRef.current + e.key).slice(-sequence.length);

      if (inputRef.current === sequence) {
        setIsEnabled((prev) => !prev);
      }
    },
    [sequence],
  );

  useEffect(() => {
    window.addEventListener("keyup", handleKeyPress);

    return () => window.removeEventListener("keyup", handleKeyPress);
  }, [handleKeyPress]);

  return isEnabled;
};
